<app-spinner
    [show]="!flagLoaded"
    [text]="'Cargando detalles de la solicitud...'"
    [type]="'fullscreen'"
    [color]="'#124e91'" [trackColor]="'#1c75bc'"
    [blurBackground]="true"
></app-spinner>

<div class="custom-header">
    <div class="container-fluid">
        <div class="header-content text-center">
            <div *ngIf="flagLoaded" class="solicitud-info">
                Detalle Solicitud -
                {{ solicitud.lastState.numberState | estadosPipe }}
                <span *ngIf="datosInscripcionCompleta?.tipoAfiliacion"
                      class="tipo-chip"
                      [ngClass]="datosInscripcionCompleta.tipoAfiliacion === 'mutual' ? 'tipo-chip--mutual' : 'tipo-chip--sindicato'">
                  {{ datosInscripcionCompleta.tipoAfiliacion === 'mutual' ? 'Mutual' : 'Sindicato' }}
                </span>
            </div>

            <div
                *ngIf="flagLabelAprobado"
                class="status-indicator state-approved"
            >
                APROBADA
            </div>
            <div
                *ngIf="flagLabelRechazado"
                class="status-indicator state-rejected"
            >
                ANULADA
                <div
                    *ngIf="solicitud.lastState.observaciones"
                    class="motivo-alerta"
                >
                    <strong>Motivo:</strong>
                    {{ solicitud.lastState.observaciones }}
                </div>
            </div>
        </div>
    </div>
    <button class="close-app-btn" (click)="closeModal()" aria-label="Cerrar">
        <i class="fas fa-times-circle"></i>
    </button>
</div>

<div class="container-fluid main-container" *ngIf="flagLoaded">
    <div class="row">
        <div class="col-md-6 left-column d-flex flex-column">
            <!-- Estado del Beneficiario -->
            <mat-expansion-panel
                [expanded]="true"
                [disabled]="true"
                class="compact-panel"
            >
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large"
                        >Estado del Beneficiario</mat-panel-title
                    >
                </mat-expansion-panel-header>
                <app-ofertas-estado-detalle
                    [solicitud]="solicitud"
                    [usuario]="usuario"
                    [beneficiario]="beneficiario"
                    [nombrePais]="nombrePais"
                    [estadoDocumentacion]="estadoDocumentacion"
                    [esSedeInscripcion]="esSedeInscripcion"
                >
                </app-ofertas-estado-detalle>

            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true" class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large">Acciones</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-card-content>
                    <button class="pdf-app-btn" (click)="exportarPDFs()" aria-label="Descargar PDFs">
                        <i class="fas fa-file-pdf"></i>
                        Descargar PDFs
                    </button>
                    <mat-card-subtitle>
                        <div class="alert alert-info" role="alert">
                            Usted va a descargar dos archivos PDF: uno con la documentación cargada y otro con los datos de inscripción y la DDJJ.
                        </div>
                    </mat-card-subtitle>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- Documentación - Fotos -->
            <mat-expansion-panel class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large"
                        >Documentación - Fotos</mat-panel-title
                    >
                </mat-expansion-panel-header>
                <mat-card-content>
                    <ng-container *ngIf="imgs.length > 0; else noFotos">
                        <app-ofertas-gallery
                            [imagenes]="imgs"
                            [id_usuario]="usuario._id"
                        ></app-ofertas-gallery>

                        <div class="image-list-container mt-4">
                            <h4 class="card-title-small">Listado de Imágenes</h4>
                            <div class="image-item" *ngFor="let img of imgs">
                                <span class="image-name">{{ nombresImagenes[img] || img }}</span>
                                <div class="image-actions">
                                    <button mat-icon-button (click)="verImagen(img)" matTooltip="Visualizar">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="descargarImagenPDF(img)" matTooltip="Descargar PDF">
                                        <mat-icon>picture_as_pdf</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noFotos>
                        <p class="no-media-msg">No se encontraron fotos</p>
                    </ng-template>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- Documentación - Archivos -->
            <mat-expansion-panel class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large"
                        >Documentación - Archivos</mat-panel-title
                    >
                </mat-expansion-panel-header>
                <mat-card-content>
                    <ng-container *ngIf="files.length > 0; else noArchivos">
                        <app-ofertas-files
                            [files]="files"
                            [usuario]="usuario"
                        ></app-ofertas-files>
                    </ng-container>
                    <ng-template #noArchivos>
                        <p class="no-media-msg">No se encontraron archivos</p>
                    </ng-template>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- Historial de Estados -->
            <mat-expansion-panel class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large"
                        >Historial de Estados</mat-panel-title
                    >
                </mat-expansion-panel-header>
                <mat-card-content>
                    <ng-container
                        *ngIf="historialConUsuario.length; else noHistorial"
                    >
                        <div class="p-3">
                            <ul class="list-group">
                                <li
                                    class="list-group-item"
                                    *ngFor="let hs of historialConUsuario"
                                >
                                    <strong>Usuario:</strong> {{ hs.userName
                                    }}<br />
                                    <strong>Estado:</strong>
                                    {{ hs.state || "N/A" }}<br />
                                    <strong>Fecha:</strong>
                                    {{ hs.updatedAt | date: "dd/MM/yyyy HH:mm"
                                    }}<br />
                                    <strong>Observaciones:</strong>
                                    {{
                                        hs.observaciones ||
                                            "No hay observaciones."
                                    }}
                                </li>
                            </ul>
                        </div>
                    </ng-container>
                    <ng-template #noHistorial>
                        <div class="text-center p-3">
                            <i class="fa fa-history fa-3x text-muted"></i>
                            <p class="mt-2 no-media-msg">
                                No hay historial de estados disponible.
                            </p>
                        </div>
                    </ng-template>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- Alertas de estado -->
            <ng-container
                *ngIf="
                    flagEnRevision ||
                        flagEnAuditoria ||
                        flagLabelAprobado ||
                        flagLabelRechazado ||
                        flagLabelEnEspera ||
                        flagLabelPresentado;
                    else incompleteAlert
                "
            >
                <span
                    *ngIf="flagLabelEnEspera"
                    class="alert alert-warning d-block text-break"
                >
                    Solicitud en espera. <strong> Motivo: </strong>
                    {{
                        solicitud.lastState?.observaciones || "Sin especificar"
                    }}
                </span>
                <span *ngIf="flagEnRevision" class="alert alert-primary"
                    >Solicitud en revisión por parte de la sede.</span
                >
                <span *ngIf="flagEnAuditoria" class="alert alert-info"
                    >Solicitud en Auditoría médica.</span
                >
                <span *ngIf="flagLabelAprobado" class="alert alert-success"
                    >Solicitud aprobada.</span
                >
                <span
                    *ngIf="flagLabelRechazado"
                    class="alert alert-danger d-block text-break"
                >
                    Solicitud anulada. <strong> Motivo: </strong>
                    {{
                        solicitud.lastState?.observaciones || "Sin especificar"
                    }}
                </span>
                <span *ngIf="flagLabelPresentado" class="alert alert-danger"
                    >Solicitud Presentada.</span
                >
            </ng-container>
        </div>

        <div class="col-md-6 right-column d-flex flex-column">
            <!-- Aprobar (solo flujo inscripción) -->
            <mat-expansion-panel [expanded]="true" class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large"
                        >Aprobar</mat-panel-title
                    >
                </mat-expansion-panel-header>
                <mat-card-content>
                    <mat-card-subtitle
                        >Si todo está correcto, aprueba la solicitud y se
                        notificará al afiliado.</mat-card-subtitle
                    >
                    <mat-card-actions>
                        <mat-slide-toggle
                            *ngIf="activarAprobar"
                            [(ngModel)]="isCheckedAprobar"
                            >Activar aprobación</mat-slide-toggle
                        >
                    </mat-card-actions>

                    <!-- Flujo inscripción (sin subida de archivos) -->
                    <section *ngIf="isCheckedAprobar" id="card-inscripcion-section">
                        <mat-expansion-panel
                            [expanded]="true"
                            [disabled]="true"
                            class="compact-panel"
                        >
                            <mat-expansion-panel-header class="clasico">
                                <mat-panel-title class="card-title-large"
                                    >Aprobar Inscripción</mat-panel-title
                                >
                            </mat-expansion-panel-header>
                            <mat-card-content>
                                <div class="alert alert-info">
                                    <strong>Proceso de Inscripción:</strong>
                                    Al aprobar la inscripción, la solicitud
                                    pasará al estado aprobado y se notificará al
                                    titular por email.
                                </div>
                            </mat-card-content>
                            <mat-card-actions class="actions-container">
                                <button
                                    mat-raised-button
                                    color="success"
                                    (click)="aprobarSolicitudInscripcion()"
                                    [disabled]="flagSpinner"
                                >
                                    Aprobar Inscripción
                                </button>
                            </mat-card-actions>
                        </mat-expansion-panel>
                    </section>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- Poner en Espera -->
            <mat-expansion-panel [expanded]="true" class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large"
                        >Poner en Espera</mat-panel-title
                    >
                </mat-expansion-panel-header>
                <mat-card-content>
                    <mat-card-subtitle>
                        <div class="alert alert-warning mt-3" role="alert">
                            <h5 class="alert-heading">Atención</h5>
                            <p>
                                Al poner en espera la solicitud, se notificará
                                al afiliado y quedará en estado de espera hasta
                                nueva revisión.
                            </p>
                        </div>
                    </mat-card-subtitle>
                    <mat-card-actions>
                        <mat-slide-toggle
                            *ngIf="activarEnEspera"
                            [(ngModel)]="isCheckedEnEspera"
                        >
                            Activar para poner en espera
                        </mat-slide-toggle>
                        <section *ngIf="isCheckedEnEspera">
                            <br />
                            <mat-form-field
                                class="motivo-text-area"
                                mat-focus-on-activation
                            >
                                <mat-label>Motivo de la espera</mat-label>
                                <textarea
                                    matInput
                                    placeholder="Describa el motivo por el cual se pone en espera..."
                                    mat-autosize="true"
                                    [(ngModel)]="motivoEspera"
                                    (input)="
                                        habilitarBotonObservaciones(
                                            motivoEspera
                                        )
                                    "
                                ></textarea>
                            </mat-form-field>
                            <br />
                            <button
                                *ngIf="activarEnEspera"
                                (click)="
                                    actualizarEstadoSolicitud(
                                        this.solicitud._id,
                                        this.iAppOfertas.estado_6.number,
                                        false,
                                        this.iAppOfertas.estado_6.name,
                                        true,
                                        motivoEspera
                                    )
                                "
                                mat-raised-button
                                color="warning"
                                [disabled]="!habilitarEnviarObservacion"
                            >
                                Poner en Espera
                            </button>
                        </section>
                    </mat-card-actions>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- Anular -->
            <mat-expansion-panel [expanded]="true" class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large"
                        >Anular</mat-panel-title
                    >
                </mat-expansion-panel-header>
                <mat-card-content>
                    <mat-card-subtitle>
                        <div class="alert alert-danger" role="alert">
                            <h5 class="alert-heading">¡Importante!</h5>
                            <p>
                                Al <strong>ANULAR</strong> una solicitud, el
                                afiliado tendrá que reenviar la autorización y
                                su documentación nuevamente.
                            </p>
                        </div>
                    </mat-card-subtitle>
                    <mat-card-actions>
                        <mat-slide-toggle
                            *ngIf="activarRechazar"
                            [(ngModel)]="isCheckedRechazar"
                            >Active la opción para anular</mat-slide-toggle
                        >
                        <section *ngIf="isCheckedRechazar">
                            <br />
                            <mat-form-field
                                class="motivo-text-area"
                                mat-focus-on-activation
                            >
                                <mat-label>Motivo de anulación</mat-label>
                                <textarea
                                    matInput
                                    placeholder="Escriba el motivo por el cual se anula la solicitud..."
                                    mat-autosize="true"
                                    [(ngModel)]="motivoRechazo"
                                    (input)="
                                        habilitarBotonObservaciones(
                                            motivoRechazo
                                        )
                                    "
                                ></textarea>
                            </mat-form-field>
                            <br />
                            <button
                                *ngIf="activarRechazar"
                                (click)="
                                    actualizarEstadoSolicitud(
                                        this.solicitud._id,
                                        this.iAppOfertas.estado_5.number,
                                        false,
                                        this.iAppOfertas.estado_5.name,
                                        true,
                                        motivoRechazo
                                    )
                                "
                                mat-raised-button
                                color="accent"
                                [disabled]="!habilitarEnviarObservacion"
                            >
                                Anular
                            </button>
                            <button
                                *ngIf="!activarRechazar"
                                mat-raised-button
                                color="warn"
                                disabled
                            >
                                Anular
                            </button>
                        </section>
                    </mat-card-actions>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- Observación Interna -->
            <mat-expansion-panel [expanded]="true" class="compact-panel">
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large">
                        Observación Interna
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-card-content>
                    <mat-card-subtitle>
                        <div class="alert alert-info" role="alert">
                            <h5 class="alert-heading">Uso Interno Administrativo</h5>
                            <p>
                                Esta observación es visible solo para administradores y no se comparte con el afiliado.
                                Úsela para anotaciones internas, seguimientos o cualquier información relevante para el equipo.
                            </p>
                        </div>
                    </mat-card-subtitle>
                    <mat-card-actions>
                        <mat-form-field class="motivo-text-area" mat-focus-on-activation>
                            <mat-label>Observación interna (solo para administradores)</mat-label>
                            <textarea
                                matInput
                                placeholder="Escriba una observación interna sobre esta solicitud..."
                                mat-autosize="true"
                                [(ngModel)]="observacionInterna"
                                (input)="habilitarBotonObservacionesInternas(observacionInterna)"
                            ></textarea>
                        </mat-form-field>
                        <br />
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="guardarObservacionInterna()"
                            [disabled]="!habilitarGuardarObservacionInterna"
                        >
                            Guardar Observación Interna
                        </button>
                    </mat-card-actions>
                </mat-card-content>
            </mat-expansion-panel>

            <!-- CONTENEDOR VISIBLE PARA LA INTERFAZ (Inscripción + DDJJ) -->
            <div id="export-inscripcion-ddjj">
                <!-- Panel de Inscripción -->
                <mat-expansion-panel
                    *ngIf="datosInscripcionCompleta"
                    [expanded]="true"
                    class="compact-panel"
                >
                    <mat-expansion-panel-header class="clasico">
                        <mat-panel-title class="card-title-large">
                            Inscripción
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-card-content>
                        <div class="data-section">
                            <div class="section-header">
                                <h5>Datos de Inscripción</h5>
                            </div>

                            <!-- Datos del Titular -->
                            <div class="data-subsection">
                                <div class="subsection-header">
                                    <h6>Titular</h6>
                                </div>
                                <div class="data-grid">
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Nombre completo:</span>
                                            <span class="field-value">
                                                {{ datosInscripcionCompleta.datosDelTitular.nombre }}
                                                {{ datosInscripcionCompleta.datosDelTitular.apellido }}
                                            </span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">DNI:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.numeroDocumento }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">CUIL:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.cuil }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Email:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.email }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Teléfono:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.telefono }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Celular:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDelTitular.celular }}</span>
                                        </div>
                                    </div>
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Fecha Nacimiento:</span>
                                            <span class="field-value">{{ formatearFecha(datosInscripcionCompleta.datosDelTitular.fechaNacimiento) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Sexo:</span>
                                            <span class="field-value">{{ mostrarSexo(datosInscripcionCompleta.datosDelTitular.sexo) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Nacionalidad:</span>
                                            <span class="field-value">{{ mostrarNacionalidad(datosInscripcionCompleta.datosDelTitular.nacionalidad) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Estado Civil:</span>
                                            <span class="field-value">{{ mostrarEstadoCivil(datosInscripcionCompleta.datosDelTitular.estadoCivil) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Régimen Laboral:</span>
                                            <span class="field-value">{{ mostrarRegimenLaboral(datosInscripcionCompleta.datosDelTitular.regimenLaboral) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Tipo Documento:</span>
                                            <span class="field-value">{{ mostrarTipoDocumento(datosInscripcionCompleta.datosDelTitular.tipoDocumento) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Fecha Ingreso Empresa:</span>
                                            <span class="field-value">{{ formatearFecha(datosInscripcionCompleta.datosDelTitular.fechaIngresoEmpresa) }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Domicilio del Titular -->
                                <div class="address-section">
                                    <div class="subsection-header">
                                        <h6>Domicilio</h6>
                                    </div>
                                    <div class="address-content">
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.direccion }}
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.numero }}
                                        <span *ngIf="datosInscripcionCompleta.datosDelTitular.domicilio.piso">
                                            - Piso: {{ datosInscripcionCompleta.datosDelTitular.domicilio.piso }}
                                        </span>
                                        <span *ngIf="datosInscripcionCompleta.datosDelTitular.domicilio.departamento">
                                            Dpto: {{ datosInscripcionCompleta.datosDelTitular.domicilio.departamento }}
                                        </span>
                                        <br />
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.localidad }},
                                        {{ datosInscripcionCompleta.datosDelTitular.domicilio.provincia }}
                                        (CP: {{ datosInscripcionCompleta.datosDelTitular.domicilio.codigoPostal }})
                                    </div>
                                </div>
                            </div>

                            <!-- Datos de la Empresa -->
                            <div class="data-subsection" *ngIf="datosInscripcionCompleta.datosDelTitular.regimenLaboral !== 1">
                                <div class="subsection-header">
                                    <h6>Datos de la Empresa</h6>
                                </div>
                                <div class="data-grid">
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Razón Social:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.razonSocial }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">CUIT:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.cuit }}</span>
                                        </div>
                                    </div>
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Domicilio:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.domicilio }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Teléfono:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.datosDeLaEmpresa.telefono }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Familiares -->
                            <div class="data-subsection" *ngIf="datosInscripcionCompleta.familiares.length > 0">
                                <div class="subsection-header">
                                    <h6>Familiares Declarados</h6>
                                </div>
                                <div class="family-list">
                                    <div *ngFor="let familiar of datosInscripcionCompleta.familiares; let i = index" class="family-member">
                                        <div class="member-header">Familiar {{ i + 1 }}</div>
                                        <div class="data-grid">
                                            <div class="data-column">
                                                <div class="data-field">
                                                    <span class="field-label">Nombre:</span>
                                                    <span class="field-value">{{ familiar.nombre }} {{ familiar.apellido }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">DNI:</span>
                                                    <span class="field-value">{{ familiar.numeroDocumento }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Parentesco:</span>
                                                    <span class="field-value">{{ mostrarParentesco(familiar.parentesco) }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Fecha Nacimiento:</span>
                                                    <span class="field-value">{{ formatearFecha(familiar.fechaNacimiento) }}</span>
                                                </div>
                                            </div>
                                            <div class="data-column">
                                                <div class="data-field">
                                                    <span class="field-label">Sexo:</span>
                                                    <span class="field-value">{{ mostrarSexo(familiar.sexo) }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Nacionalidad:</span>
                                                    <span class="field-value">{{ mostrarNacionalidad(familiar.nacionalidad) }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">Email:</span>
                                                    <span class="field-value">{{ familiar.email || "No especificado" }}</span>
                                                </div>
                                                <div class="data-field">
                                                    <span class="field-label">CUIL:</span>
                                                    <span class="field-value">{{ familiar.cuil || "No especificado" }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="!datosInscripcionCompleta" class="no-data-message">
                            <p>No hay datos de inscripción disponibles</p>
                        </div>
                    </mat-card-content>
                </mat-expansion-panel>

                <!-- Panel de Declaración Jurada (completada) -->
                <mat-expansion-panel
                    *ngIf="datosInscripcionCompleta && solicitud.ddjj?.acepta && solicitud.ddjj?.contenido"
                    [expanded]="true"
                    class="compact-panel"
                >
                    <mat-expansion-panel-header class="clasico">
                        <mat-panel-title class="card-title-large">
                            Declaración Jurada
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-card-content id="declaracion-jurada-content" class="declaracion-jurada-scrollable">
                        <div class="data-section">
                            <div class="section-header">
                                <h5>Declaración Jurada</h5>
                            </div>

                            <!-- Datos Personales DDJJ -->
                            <div class="data-subsection">
                                <div class="subsection-header">
                                    <h6>Datos Personales</h6>
                                </div>
                                <div class="data-grid">
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Nombre:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.nombre }} {{ datosInscripcionCompleta.ddjj.datosPersonales.apellido }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">DNI:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.dni }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Fecha Nacimiento:</span>
                                            <span class="field-value">{{ formatearFecha(datosInscripcionCompleta.ddjj.datosPersonales.fechaNacimiento) }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Domicilio:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.domicilio }}</span>
                                        </div>
                                    </div>
                                    <div class="data-column">
                                        <div class="data-field">
                                            <span class="field-label">Localidad:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.localidad }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Teléfono:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.telefono }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">Empleador:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.empleador }}</span>
                                        </div>
                                        <div class="data-field">
                                            <span class="field-label">CUIT:</span>
                                            <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.cuit }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="data-field-full">
                                    <span class="field-label">Grupo Sanguíneo:</span>
                                    <span class="field-value">{{ mostrarGrupoSanguineo(datosInscripcionCompleta.ddjj.datosPersonales.grupoSanguineo) }}</span>
                                    <span class="field-label ml-3">Factor RH:</span>
                                    <span class="field-value">{{ mostrarFactorRh(datosInscripcionCompleta.ddjj.datosPersonales.factorRh) }}</span>
                                </div>
                                <div class="data-field-full" *ngIf="datosInscripcionCompleta.ddjj.datosPersonales.otros">
                                    <span class="field-label">Otros datos:</span>
                                    <span class="field-value">{{ datosInscripcionCompleta.ddjj.datosPersonales.otros }}</span>
                                </div>
                            </div>

                            <!-- Secciones médicas -->
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.antecedentesMedicos">
                                <div class="subsection-header"><h6>Antecedentes Médicos</h6></div>
                                <div class="medical-content">{{ mostrarAntecedentesMedicos(datosInscripcionCompleta.ddjj.antecedentesMedicos) }}</div>
                            </div>
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.habitosFisiologicos">
                                <div class="subsection-header"><h6>Hábitos Fisiológicos</h6></div>
                                <div class="medical-content">{{ mostrarHabitosFisiologicos(datosInscripcionCompleta.ddjj.habitosFisiologicos) }}</div>
                            </div>
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.habitosToxicos">
                                <div class="subsection-header"><h6>Hábitos Tóxicos</h6></div>
                                <div class="medical-content">{{ mostrarHabitosToxicos(datosInscripcionCompleta.ddjj.habitosToxicos) }}</div>
                            </div>
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.antecedentesGinecoObstetricos">
                                <div class="subsection-header"><h6>Antecedentes Gineco-Obstétricos</h6></div>
                                <div class="medical-content">{{ mostrarAntecedentesGinecoObstetricos(datosInscripcionCompleta.ddjj.antecedentesGinecoObstetricos) }}</div>
                            </div>

                            <!-- Antecedentes Familiares -->
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.antecedentesFamiliares">
                                <div class="subsection-header"><h6>Antecedentes Familiares</h6></div>
                                <div class="medical-content">
                                    <div class="antecedentes-detallados">
                                        <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesFamiliares)" class="antecedente-item">
                                            <strong>{{ formatKey(key) }}:</strong>
                                            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key].tiene) }}
                                            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesFamiliares[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key])">
                                                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key]) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Antecedentes Patológicos -->
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.antecedentesPatologicos">
                                <div class="subsection-header"><h6>Antecedentes Patológicos</h6></div>
                                <div class="medical-content">
                                    <div class="antecedentes-detallados">
                                        <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesPatologicos)" class="antecedente-item">
                                            <strong>{{ formatKey(key) }}:</strong>
                                            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key].tiene) }}
                                            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesPatologicos[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key])">
                                                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key]) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Síntomas y Experiencias -->
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.sintomasYExperiencias">
                                <div class="subsection-header"><h6>Síntomas y Experiencias</h6></div>
                                <div class="medical-content">
                                    <div class="antecedentes-detallados">
                                        <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.sintomasYExperiencias)" class="antecedente-item">
                                            <strong>{{ formatKey(key) }}:</strong>
                                            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key].tiene) }}
                                            <span *ngIf="datosInscripcionCompleta.ddjj.sintomasYExperiencias[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key])">
                                                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key]) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Antecedentes Quirúrgicos -->
                            <div class="medical-section" *ngIf="datosInscripcionCompleta.ddjj.antecedentesQuirurgicos">
                                <div class="subsection-header"><h6>Antecedentes Quirúrgicos</h6></div>
                                <div class="medical-content">
                                    <div class="antecedentes-detallados">
                                        <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos)" class="antecedente-item">
                                            <strong>{{ formatKey(key) }}:</strong>
                                            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key].tiene) }}
                                            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key])">
                                                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key]) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Información de aceptación -->
                            <div class="declaration-summary">
                                <div class="summary-header">Declaración Jurada Completada</div>
                                <div class="summary-content">
                                    <div class="data-field">
                                        <span class="field-label">Fecha de declaración:</span>
                                        <span class="field-value">{{ formatearFechaHora(solicitud.ddjj.timeMark) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-expansion-panel>

                <!-- Mensaje cuando la DDJJ no está completada -->
                <mat-expansion-panel
                    *ngIf="datosInscripcionCompleta && !(solicitud.ddjj?.acepta && solicitud.ddjj?.contenido)"
                    [expanded]="true"
                    class="compact-panel"
                >
                    <mat-expansion-panel-header class="clasico">
                        <mat-panel-title class="card-title-large">Declaración Jurada</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-card-content>
                        <div class="alert alert-warning">
                            <strong>Importante:</strong> El afiliado aún no ha completado la Declaración Jurada.
                        </div>
                    </mat-card-content>
                </mat-expansion-panel>
            </div>
            <!-- FIN del contenedor visible de exportación -->

            <!-- Deshacer Anulación -->
            <mat-expansion-panel
                [expanded]="true"
                class="compact-panel"
                *ngIf="flagLabelRechazado"
            >
                <mat-expansion-panel-header class="clasico">
                    <mat-panel-title class="card-title-large">Deshacer Anulación</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-card-content>
                    <mat-card-actions>
                        <p class="text-muted mt-2">La solicitud pasará a revisión</p>
                        <button
                            mat-raised-button
                            (click)="deshacerAnulacion()"
                            [disabled]="!activarDeshacerAnulacion"
                        >
                            Deshacer Anulación
                        </button>
                    </mat-card-actions>
                </mat-card-content>
            </mat-expansion-panel>
        </div>
    </div>

    <!-- NUEVO: Contenedor OCULTO para exportación limpia a PDF -->
    <div id="export-inscripcion-ddjj-pdf"
        style="display: none;">
    
        <!-- Página 1: Inscripción (datos del titular, domicilio, empresa, familiares) -->
        <div class="page-a4">
            <h2 style="margin:0 0 10px;">Inscripción y Declaración Jurada</h2>
            <p><strong>Solicitud N°:</strong> {{ solicitud._nro || solicitud._id }}</p>
            <h3 style="border-bottom:1px solid #ccc; margin-top:10px;">Datos de Inscripción</h3>

            <h4>Titular</h4>
            <div style="display:flex; flex-wrap:wrap;">
            <div style="flex:1; min-width:250px;">
                <p><strong>Nombre completo:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.nombre }} {{ datosInscripcionCompleta?.datosDelTitular?.apellido }}</p>
                <p><strong>DNI:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.numeroDocumento }}</p>
                <p><strong>CUIL:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.cuil }}</p>
                <p><strong>Email:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.email }}</p>
                <p><strong>Teléfono:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.telefono }}</p>
                <p><strong>Celular:</strong> {{ datosInscripcionCompleta?.datosDelTitular?.celular }}</p>
            </div>
            <div style="flex:1; min-width:250px;">
                <p><strong>Fecha Nacimiento:</strong> {{ formatearFecha(datosInscripcionCompleta?.datosDelTitular?.fechaNacimiento) }}</p>
                <p><strong>Sexo:</strong> {{ mostrarSexo(datosInscripcionCompleta?.datosDelTitular?.sexo) }}</p>
                <p><strong>Nacionalidad:</strong> {{ mostrarNacionalidad(datosInscripcionCompleta?.datosDelTitular?.nacionalidad) }}</p>
                <p><strong>Estado Civil:</strong> {{ mostrarEstadoCivil(datosInscripcionCompleta?.datosDelTitular?.estadoCivil) }}</p>
                <p><strong>Régimen Laboral:</strong> {{ mostrarRegimenLaboral(datosInscripcionCompleta?.datosDelTitular?.regimenLaboral) }}</p>
                <p><strong>Tipo Documento:</strong> {{ mostrarTipoDocumento(datosInscripcionCompleta?.datosDelTitular?.tipoDocumento) }}</p>
                <p><strong>Fecha Ingreso Empresa:</strong> {{ formatearFecha(datosInscripcionCompleta?.datosDelTitular?.fechaIngresoEmpresa) }}</p>
            </div>
            </div>

            <h4>Domicilio</h4>
            <p>
            {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.direccion }}
            {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.numero }}
            <span *ngIf="datosInscripcionCompleta?.datosDelTitular?.domicilio?.piso"> - Piso: {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.piso }} </span>
            <span *ngIf="datosInscripcionCompleta?.datosDelTitular?.domicilio?.departamento"> Dpto: {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.departamento }} </span>
            <br/>
            {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.localidad }}, {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.provincia }} (CP: {{ datosInscripcionCompleta?.datosDelTitular?.domicilio?.codigoPostal }})
            </p>

            <div *ngIf="datosInscripcionCompleta?.datosDelTitular?.regimenLaboral !== 1">
            <h4>Datos de la Empresa</h4>
            <p><strong>Razón Social:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.razonSocial }}</p>
            <p><strong>CUIT:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.cuit }}</p>
            <p><strong>Domicilio:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.domicilio }}</p>
            <p><strong>Teléfono:</strong> {{ datosInscripcionCompleta?.datosDeLaEmpresa?.telefono }}</p>
            </div>

            <div *ngIf="datosInscripcionCompleta?.familiares?.length">
            <h4>Familiares Declarados</h4>
            <div *ngFor="let familiar of datosInscripcionCompleta.familiares; let i = index" style="margin-bottom:8px; border:1px solid #ddd; padding:6px;">
                <strong>Familiar {{ i + 1 }}</strong>
                <p><strong>Nombre:</strong> {{ familiar.nombre }} {{ familiar.apellido }}</p>
                <p><strong>DNI:</strong> {{ familiar.numeroDocumento }}</p>
                <p><strong>Parentesco:</strong> {{ mostrarParentesco(familiar.parentesco) }}</p>
                <p><strong>Fecha Nacimiento:</strong> {{ formatearFecha(familiar.fechaNacimiento) }}</p>
                <p><strong>Sexo:</strong> {{ mostrarSexo(familiar.sexo) }}</p>
                <p><strong>Nacionalidad:</strong> {{ mostrarNacionalidad(familiar.nacionalidad) }}</p>
                <p><strong>Email:</strong> {{ familiar.email || 'No especificado' }}</p>
                <p><strong>CUIL:</strong> {{ familiar.cuil || 'No especificado' }}</p>
            </div>
            </div>
        </div>

        <!-- Página 2: DDJJ - Datos Personales, Antecedentes Médicos, Hábitos Fisiológicos, Hábitos Tóxicos, Gineco-Obstétricos -->
        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido">
            <h3 style="border-bottom:1px solid #ccc; margin-top:0;">Declaración Jurada</h3>

            <h4>Datos Personales</h4>
            <p><strong>Nombre:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.nombre }} {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.apellido }}</p>
            <p><strong>DNI:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.dni }}</p>
            <p><strong>Fecha Nacimiento:</strong> {{ formatearFecha(datosInscripcionCompleta?.ddjj?.datosPersonales?.fechaNacimiento) }}</p>
            <p><strong>Domicilio:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.domicilio }}</p>
            <p><strong>Localidad:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.localidad }}</p>
            <p><strong>Teléfono:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.telefono }}</p>
            <p><strong>Empleador:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.empleador }}</p>
            <p><strong>CUIT:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.cuit }}</p>
            <p><strong>Grupo Sanguíneo:</strong> {{ mostrarGrupoSanguineo(datosInscripcionCompleta?.ddjj?.datosPersonales?.grupoSanguineo) }} - <strong>Factor RH:</strong> {{ mostrarFactorRh(datosInscripcionCompleta?.ddjj?.datosPersonales?.factorRh) }}</p>
            <p *ngIf="datosInscripcionCompleta?.ddjj?.datosPersonales?.otros"><strong>Otros:</strong> {{ datosInscripcionCompleta?.ddjj?.datosPersonales?.otros }}</p>

            <h4>Antecedentes Médicos</h4>
            <p>{{ mostrarAntecedentesMedicos(datosInscripcionCompleta?.ddjj?.antecedentesMedicos) || 'No especificado' }}</p>

            <h4>Hábitos Fisiológicos</h4>
            <p>{{ mostrarHabitosFisiologicos(datosInscripcionCompleta?.ddjj?.habitosFisiologicos) || 'No especificado' }}</p>

            <h4>Hábitos Tóxicos</h4>
            <p>{{ mostrarHabitosToxicos(datosInscripcionCompleta?.ddjj?.habitosToxicos) || 'No especificado' }}</p>

            <h4>Antecedentes Gineco-Obstétricos</h4>
            <p>{{ mostrarAntecedentesGinecoObstetricos(datosInscripcionCompleta?.ddjj?.antecedentesGinecoObstetricos) || 'No especificado' }}</p>
        </div>

        <!-- Páginas siguientes: cada grupo de antecedentes en su propia página, si existen datos -->
        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.antecedentesFamiliares">
            <h4>Antecedentes Familiares</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesFamiliares)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesFamiliares[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesFamiliares[key]) }}
            </span>
            </div>
        </div>

        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.antecedentesPatologicos">
            <h4>Antecedentes Patológicos</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesPatologicos)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesPatologicos[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesPatologicos[key]) }}
            </span>
            </div>
        </div>

        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.sintomasYExperiencias">
            <h4>Síntomas y Experiencias</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.sintomasYExperiencias)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.sintomasYExperiencias[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.sintomasYExperiencias[key]) }}
            </span>
            </div>
        </div>

        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido && datosInscripcionCompleta?.ddjj?.antecedentesQuirurgicos">
            <h4>Antecedentes Quirúrgicos</h4>
            <div *ngFor="let key of objectKeys(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos)" style="margin-bottom:4px;">
            <strong>{{ formatKey(key) }}:</strong>
            {{ mostrarSiNo(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key].tiene) }}
            <span *ngIf="datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key].tiene && obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key])">
                - {{ obtenerDetalle(datosInscripcionCompleta.ddjj.antecedentesQuirurgicos[key]) }}
            </span>
            </div>
        </div>

        <!-- Fecha de declaración jurada (última página opcional) -->
        <div class="page-a4" *ngIf="solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido">
            <p><strong>Fecha de declaración:</strong> {{ formatearFechaHora(solicitud.ddjj.timeMark) }}</p>
        </div>
        
        <!-- Si no hay DDJJ completada, mostramos aviso en una página -->
        <div class="page-a4" *ngIf="!(solicitud?.ddjj?.acepta && solicitud?.ddjj?.contenido)" style="color:#a94442; background:#f2dede; padding:10px;">
            <strong>Importante:</strong> El afiliado aún no ha completado la Declaración Jurada.
        </div>
    </div>
    <!-- FIN del contenedor oculto -->

    <ng-template #incompleteAlert>
        <span class="alert alert-warning"
            >El afiliado no completó la solicitud y la dejó parcial sin la
            documentación mínima</span
        >
    </ng-template>
</div>
